import server_api from "data/server_apis/server_api";

const auth = (data) => {
  let resp = server_api.post("/api/token", data);
  return resp;
};

export { auth };
